import React from "react";
import HeaderTwo from "../common/header/HeaderTwo";
import HeroTwo from "../components/hero/HeroTwo";
import FeatureTwo from "../components/features/FeatureTwo";
import AboutOne from "../components/about/AboutOne";
import VisitedOne from "../components/visited/VisitedOne";
import TeamOne from "../components/team/TeamOne";
import CategoriesTwo from "../components/categories/CategoriesTwo";
import VideoTwo from "../components/video/VideoTwo";
import CounterOne from "../components/counter/CounterOne";
import BrandTwo from "../components/brand/BrandTwo";
import BlogOne from "../components/blog/BlogOne";
import FooterTwo from "../common/footer/FooterTwo";

const HomeTwo = () => {
    return (
        <>
            <HeaderTwo />
            <HeroTwo />
            <FeatureTwo />
            <AboutOne />
            <VisitedOne />
            <TeamOne />
            <CategoriesTwo />
            <VideoTwo />
            <CounterOne />
            <BrandTwo />
            <BlogOne />
            <FooterTwo />
        </>
    )
}

export default HomeTwo;